import React from 'react';
import { Link } from 'react-router-dom';
import { LogIn } from 'lucide-react';
import AuthSplitShell from '../components/AuthSplitShell';

const LoggedOut = () => (
  <AuthSplitShell
    panel
    title="Signed out"
    subtitle="You have been securely logged out of your account."
    heroLead="Thank you for using Jet Shipping Cargo. Sign in again anytime to track your shipments."
  >
    <div className="auth-split-card">
      <p style={{ margin: '0 0 1.25rem', color: '#64748b', lineHeight: 1.5 }}>
        Thank you for using Jet Shipping Cargo.
      </p>
      <Link to="/login" className="btn">
        <LogIn className="w-5 h-5" aria-hidden />
        Sign in again
      </Link>
      <p className="auth-split-links" style={{ textAlign: 'center', margin: '1rem 0 0' }}>
        <Link to="/">Return to home</Link>
      </p>
    </div>
  </AuthSplitShell>
);

export default LoggedOut;
